<template>
  <div v-if="!isLoadingPage">
    <div v-if="permission !== null">
      <div v-if="permission.read_perm == 1">
        <div class="fluid" id="invoiceList">
          <div>
            <div class="invoice-list-dev">
              <v-card elevation="0" class="px-3 py-2" style="width: 100%">
                <v-row>
                  <v-col
                    cols="12"
                    class="d-flex"
                    style="
                      position: relative;
                      padding: 0 20px;
                      text-align: center;
                      margin-top: 20px;
                    "
                  >
                    <h4
                      class="indigo--text"
                      style="font-weight: bold; margin: auto"
                    >
                      LIST BILL
                      <v-tooltip bottom color="grey">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            v-bind="attrs"
                            v-on="on"
                            x-small
                            text
                            icon
                            color="grey darken-2"
                            @click="getDataFromApi"
                          >
                            <v-icon small>mdi-refresh</v-icon>
                          </v-btn>
                        </template>
                        <span>refresh page</span>
                      </v-tooltip>
                    </h4>
                  </v-col>
                  <v-col cols="12">
                    <div>
                      <v-toolbar
                        class="invoice-list-toolbar-1"
                        flat
                        style="
                          height: 60px;
                          border-radius: 10px 10px 0 0;
                          margin-top: 15px;
                        "
                      >
                        <div
                          class="d-flex align-content-start justify-between"
                          style="width: 100%"
                        >
                          <div style="width: 210px">
                            <v-autocomplete
                              v-model="paramAPI.company_id"
                              label="Company"
                              item-text="name"
                              item-value="id"
                              style="font-size: 12px"
                              return-object
                              dense
                              outlined
                              clearable
                              @change="companyWatcher"
                              :items="dropdown.company"
                              :disabled="isDisableCompanyDropdown"
                            ></v-autocomplete>
                          </div>
                          <div style="width: 210px; margin-left: 15px">
                            <!-- <v-select
                              label="Status"
                              v-model="paramAPI.state"
                              :items="dropdown.status"
                              style="font-size: 12px"
                              item-text="name"
                              item-value="id"
                              return-id
                              dense
                              clearable
                              outlined
                              disabled
                              @change="statusWatcher"
                            ></v-select> -->
                          </div>
                          <div
                            style="
                              width: 390px;
                              height: 45px;
                              margin-left: auto;
                            "
                          >
                            <v-text-field
                              v-model="paramAPI.keyword"
                              label="cari dokumen"
                              type="search"
                              outlined
                              dense
                              append-icon="mdi-magnify"
                              style="margin-left: 15px; font-size: 12px"
                              @keyup.enter="searchEnter"
                              :disabled="loading"
                            ></v-text-field>
                          </div>
                        </div>
                      </v-toolbar>
                      <v-toolbar
                        class="invoice-list-toolbar-1"
                        flat
                        style="
                          height: 60px;
                          border-radius: 10px 10px 0 0;
                          margin-top: 10px;
                        "
                      >
                        <div
                          class="d-flex align-content-center justify-space-between"
                          style="width: 100%"
                        >
                          <div style="width: 160px">
                            <v-autocomplete
                              v-model="actionValue"
                              label="Action"
                              item-text="name"
                              item-value="id"
                              style="font-size: 12px"
                              return-id
                              dense
                              outlined
                              clearable
                              @click:clear="clearSelectedData"
                              @change="actionSelect"
                              :items="itemsAction"
                              :disabled="selectedData.length == 0"
                            ></v-autocomplete>
                          </div>
                          <div style="width: 260px; margin-left: 15px">
                            <v-autocomplete
                              v-model="paramAPI.partner_id"
                              :items="dropdown.partner"
                              :search-input.sync="searchPartner"
                              :item-text="'display_name'"
                              item-value="id"
                              label="Customer"
                              return-id
                              outlined
                              clearable
                              dense
                              @change="partnerWatcher"
                              @keydown.enter.prevent="
                                dropdownPartner(searchPartner)
                              "
                            ></v-autocomplete>
                          </div>
                          <div style="width: 180px; margin-left: auto">
                            <v-text-field
                              dense
                              v-model="paramAPI.start_date"
                              label="Dari Tanggal"
                              type="date"
                              name="startdate"
                              style="height: 30px"
                              step="1"
                              outlined
                              clearable
                              @change="startDateWatcher"
                            />
                          </div>
                          <div style="width: 180px; margin-left: 15px">
                            <v-text-field
                              dense
                              v-model="paramAPI.end_date"
                              label="Sampai Tanggal"
                              type="date"
                              name="startdate"
                              style="height: 30px"
                              step="1"
                              outlined
                              clearable
                              @change="endDateWatcher"
                            />
                          </div>
                        </div>
                      </v-toolbar>
                    </div>
                  </v-col>

                  <v-col cols="12" style="width: 100%">
                    <v-data-table
                      v-if="
                        tabelData && (tabelData.length > 0 || !skeleton_loading)
                      "
                      v-model="selectedData"
                      mobile-breakpoint="0"
                      fixed-header
                      height="50vh"
                      :headers="invoiceHeaders"
                      style="cursor: pointer"
                      :items="tabelData"
                      :loading="loading"
                      item-key="id"
                      :options.sync="options"
                      :footer-props="{
                        showFirstLastPage: true,
                        showCurrentPage: true,
                        itemsPerPageOptions: [1, 3, 5, 10, 15, 100, 500]
                      }"
                      :server-items-length="totalData"
                      :page="paramAPI.page"
                      @update:page="updatePage"
                      :items-per-page="paramAPI.itemsPerPage"
                      @update:items-per-page="updateItemPerPage"
                      show-select
                    >
                      <!-- <template v-slot:[`item.no`]="{ index }">
                        <div
                          style="
                            font-size: 14px;
                            padding: 0;
                            display: flex;
                            flex-direction: row;
                          "
                        >
                          {{ index + 1 + paramAPI.offset * paramAPI.limit }}
                        </div>
                      </template> -->
                      <template v-slot:[`item.name`]="{ item }">
                        <div
                          :style="`min-width:120px; font-size:11px; padding: 0; display: flex; flex-direction: row; justify-content: start; align-items:center;`"
                        >
                          {{ item.name }}
                        </div>
                      </template>
                      <template v-slot:[`item.company`]="{ item }">
                        <div
                          :style="`width:150px; font-size:11px; padding: 0; display: flex; flex-direction: row; justify-content: start; align-items:center;`"
                        >
                          {{ item.company.name }}
                        </div>
                      </template>
                      <template v-slot:[`item.partner`]="{ item }">
                        <div
                          :style="`width:150px; font-size:11px; padding: 0; display: flex; flex-direction: row; justify-content: start; align-items:center;`"
                        >
                          {{
                            item.partner != null
                              ? item.partner.display_name
                              : ''
                          }}
                        </div>
                      </template>
                      <template v-slot:[`item.ref`]="{ item }">
                        <div
                          :style="`width:120px; font-size:11px; padding: 0; display: flex; flex-direction: row; justify-content: start; align-items:center;`"
                        >
                          {{ item.ref }}
                        </div>
                      </template>
                      <template v-slot:[`item.invoice_date`]="{ item }">
                        <div
                          style="
                            width: 100px;
                            font-size: 11px;
                            padding: 0;
                            display: flex;
                            flex-direction: row;
                          "
                        >
                          {{ convertDate(item.invoice_date) }}
                        </div>
                      </template>
                      <template v-slot:[`item.state`]="{ item }">
                        <div
                          :style="`text-transform:uppercase; font-size:11px; font-weight:bolder; padding: 0; display: flex; flex-direction: row;`"
                        >
                          {{ item.state }}
                        </div>
                      </template>
                      <template v-slot:[`item.bill_date`]="{ item }">
                        <div
                          style="
                            width: 100px;
                            font-size: 11px;
                            padding: 0;
                            display: flex;
                            flex-direction: row;
                          "
                        >
                          {{ convertDate(item.invoice_date) }}
                        </div>
                      </template>
                      <template v-slot:[`item.createdAt`]="{ item }">
                        <div
                          style="
                            width: 100px;
                            font-size: 11px;
                            padding: 0;
                            display: flex;
                            flex-direction: row;
                          "
                        >
                          {{ convertDate(item.createdAt) }}
                        </div>
                      </template>
                      <template v-slot:[`item.invoice_date_due`]="{ item }">
                        <div
                          style="
                            width: 100px;
                            font-size: 11px;
                            padding: 0;
                            display: flex;
                            flex-direction: row;
                          "
                        >
                          {{ convertDate(item.invoice_date_due) }}
                        </div>
                      </template>
                      <template
                        v-slot:[`item.amount_untaxed_signed`]="{ item }"
                      >
                        <div style="width: 100px; font-size: 12px">
                          {{ priceConvert(item.amount_untaxed_signed) }}
                        </div>
                      </template>
                      <template v-slot:[`item.amount_total_signed`]="{ item }">
                        <div style="width: 100px; font-size: 12px">
                          {{ priceConvert(item.amount_total_signed) }}
                        </div>
                      </template>
                      <template
                        v-slot:[`item.amount_residual_signed`]="{ item }"
                      >
                        <div style="width: 100px; font-size: 12px">
                          {{ priceConvert(item.amount_residual_signed) }}
                        </div>
                      </template>
                    </v-data-table>
                    <v-skeleton-loader
                      v-else
                      style="width: 100%"
                      type="table-heading, table-tbody, table-tfoot"
                    ></v-skeleton-loader>
                  </v-col>
                </v-row>
              </v-card>
            </div>
          </div>
          <!-- FOrm Payreq -->
          <div>
            <FormPayreq
              @closeFormPayreq="openFormPayreq"
              :isBill="true"
              :payment_request_detail="payment_request_detail"
            />
          </div>
        </div>
      </div>
    </div>
    <v-card
      v-else
      class="mx-auto"
      width="100%"
      style="
        z-index: 3;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 12px;
        position: fixed;
        top: 0;
        height: 100%;
        left: 0;
        right: 0;
        background: rgba(255, 255, 255);
      "
    >
      YOU CANNOT ACCESS THIS PAGE
    </v-card>
  </div>
  <div v-else>
    <v-card
      class="mx-auto"
      width="100%"
      style="
        z-index: 3;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 12px;
        position: fixed;
        top: 0;
        height: 100%;
        left: 0;
        right: 0;
        background: rgba(255, 255, 255);
      "
    >
      <v-progress-circular :size="170" :width="10" color="blue" indeterminate
        >Loading...</v-progress-circular
      >
    </v-card>
  </div>
</template>
<script>
import axios from 'axios'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import buildType from '../../../services/buildType.js'
import { globalMixin } from '../../../mixin/globalMixin.js'
import XLSX from 'xlsx'
// import moment from 'moment'
// import ScheduleImport from './Import.vue'
const env = process.env.VUE_APP_BUILD_TYPE
export default {
  name: 'msovertime',
  mixins: [globalMixin],
  components: {
    FormPayreq: () => import('./FormBillingPayreq.vue')
  },
  data: () => ({
    editDialog: false,
    settingDialog: false,
    config: require('../../../services/config.json')[env],
    proc: buildType.apiURL('proc'),
    hrsApi: buildType.apiURL('hrs'),
    eSanqua: buildType.apiURL('esanqua'),
    odooApi: buildType.apiURL('odoo'),
    build: process.env.VUE_APP_BUILD_TYPE,
    permission: null,
    appLevel: null,
    userLevel: null,
    isLoadingPage: true,
    isDisableCompanyDropdown: false,
    paramAPI: {
      page: 1,
      keyword: '',
      offset: 0,
      limit: 10,
      itemsPerPage: 10,
      sortBy: 'createdAt',
      sortType: 'asc',
      company_id: null,
      department_id: null,
      employee_id: null,
      mode: 1,
      state: 'posted',
      documentType: 1,
      start_date: null,
      end_date: null,
      vendor_id: null,
      partner_id: null
    },
    totalData: 0,
    isEdit: false,

    options: {},
    actionValue: 0,
    tabelData: [],
    loading: false,
    dropdown: {
      company: [],
      // department: [],
      status: [],
      vendor: [],
      unit: [],
      partner: []
      // currency: []
    },
    skeleton_loading: true,
    vendorSearch: null,
    selectVendor: null,
    itemsAction: [],
    selectedData: [],
    payment_request_detail: [],
    searchPartner: null
  }),

  async mounted() {
    if (
      this.getUserProfile.employee.company.plant_id == 5 ||
      this.getUserProfile.employee.company.plant_id == 6
    ) {
      this.appLevel = this.config.application.ecatalogue.userLevel
      this.appLevel.administrator =
        this.config.application.all.userLevel.administrator
      this.getDataMenu()
      // this.getDataFromApi()
    } else {
      this.isLoadingPage = false
    }
  },
  computed: {
    // , 'getDropdownPlant'
    ...mapGetters(['getUserProfile', 'getInvoicePageQuery']),
    invoiceHeaders() {
      const arrHeaders = [
        {
          text: 'Number',
          value: 'name',
          align: 'left',
          sortable: true
        },
        {
          text: 'Vendor',
          value: 'partner',
          align: 'left',
          sortable: true
        },
        {
          text: 'Reference',
          value: 'ref',
          align: 'left',
          sortable: true
        },
        {
          text: 'Invoice Date',
          value: 'invoice_date',
          sortable: true
        },
        {
          text: 'Company',
          value: 'company',
          sortable: false
        },
        {
          text: 'Due Date',
          value: 'invoice_date_due',
          align: 'left',
          sortable: true
        },
        {
          text: 'Tax Exclude',
          value: 'amount_untaxed_signed',
          sortable: false
        },
        {
          text: 'Total',
          value: 'amount_total_signed',
          sortable: false
        },
        {
          text: 'Amount Due',
          value: 'amount_residual_signed',
          align: 'left',
          sortable: true
        },
        {
          text: 'Bill Date',
          value: 'bill_date',
          sortable: true
        },
        {
          text: 'Create Date',
          value: 'createdAt',
          sortable: true
        },
        {
          text: 'Status',
          value: 'state',
          align: 'left',
          sortable: false
        }
      ]
      return arrHeaders
    }
  },
  watch: {
    options: {
      handler(newVal, oldVal) {
        console.log('options handle', newVal, oldVal)
        if (
          newVal.page !== oldVal.page || newVal.itemsPerPage !== oldVal.itemsPerPage
        ) {
          return
        }
        if (
          this.options.sortBy.length === 1 &&
          this.options.sortDesc.length === 1
        ) {
          this.paramAPI.sortType = this.options.sortDesc[0] ? 'desc' : 'asc'
          this.paramAPI.sortBy =
            this.options.sortBy[0] == 'document_no'
              ? 'id'
              : this.options.sortBy[0]
          // this.paramAPI.sortBy = 'id'
        } else {
          this.paramAPI.sortType = 'asc'
          this.paramAPI.sortBy = 'id'
        }
        console.log('trigger by options wathcer>>>')
        this.resetSomeParam()
        this.getDataFromApi()
      },
      deep: true
    },
    selectedData() {
      this.itemsAction = [{ id: 0, name: '' }]
      const arrData = this.selectedData

      if (arrData.length > 0) {
        this.itemsAction.push({ id: 1, name: 'Export' })
        // check if all selected item have same company & vendor
        const isSameCompany =
          arrData.length > 0 &&
          arrData.every((item) => item.company_id == arrData[0].company_id)
        const isSameVendor =
          arrData.length > 0 &&
          arrData.every((item) => item.partner_id == arrData[0].partner_id)

        if (isSameCompany && isSameVendor) {
          this.itemsAction.push({ id: 2, name: 'Buat Payreq' })
        }
      }
    }
  },
  methods: {
    ...mapActions(['menu_access', 'getMenuId']),
    ...mapMutations(['setInvoicePageQuery', 'setInvoiceQueue']),
    clearSelectedData() {
      this.actionValue = 0
      this.selectedData = []
      this.payment_request_detail = []
    },
    actionSelect(event) {
      switch (event) {
        case 0:
          this.clearSelectedData()
          break
        case 1:
          this.exportData()
          break
        case 2:
          this.openFormPayreq('open')
          break
      }
    },
    exportData() {
      this.showMsgDialog('question', 'Export Data Sekarang', true).then(
        (res) => {
          if (res.isConfirmed) {
            console.log(this.selectedData)
            const arrData = []
            for (let i = 0; i < this.selectedData.length; i++) {
              const xTotal = parseFloat(
                this.selectedData[i].amount_total_signed
              )
              const param = {
                odoo_bill_no: this.selectedData[i].name,
                invoice_no: this.selectedData[i].ref,
                invoice_date: this.selectedData[i].date,
                vendor_code:
                  this.selectedData[i].partner != null
                    ? this.selectedData[i].partner.code
                    : '',
                vendor_name:
                  this.selectedData[i].partner != null
                    ? this.selectedData[i].partner.name
                    : '',
                total_after_tax: Math.abs(xTotal),
                receive_invoice_date: this.selectedData[i].invoice_date,
                invoice_due_date: this.selectedData[i].invoice_date_due,
                deduction: 0,
                debt_value: Math.abs(xTotal - 0),
                company_id:
                  this.selectedData[i].company != null
                    ? this.selectedData[i].company.code_plant
                    : null
              }
              arrData.push(param)
            }
            this.downloadExcell(arrData)
          } else {
            this.clearSelectedData()
          }
        }
      )
    },
    downloadExcell(arrData) {
      console.log(arrData)
      const data = XLSX.utils.json_to_sheet(arrData)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, data, 'data')
      XLSX.writeFile(wb, 'account_move.xlsx')
    },
    openFormPayreq(val) {
      if (val == 'open') {
        const xArrData = this.selectedData
        for (let i = 0; i < xArrData.length; i++) {
          const xTotal = parseFloat(xArrData[i].amount_total_signed)
          const param = {
            odoo_bill_no: xArrData[i].name,
            invoice_no: xArrData[i].ref,
            invoice_date: xArrData[i].date,
            vendor_code:
              xArrData[i].partner != null ? xArrData[i].partner.code : '',
            vendor_name:
              xArrData[i].partner != null ? xArrData[i].partner.name : '',
            total_after_tax: Math.abs(xTotal),
            receive_invoice_date: xArrData[i].invoice_date,
            invoice_due_date: xArrData[i].invoice_date_due,
            deduction: 0,
            debt_value: Math.abs(xTotal - 0)
          }
          if (xArrData[i].company) {
            Object.assign(param, {
              company_id: xArrData[i].company.code_plant
            })
          } else {
            Object.assign(param, {
              company_id: this.paramAPI.company_id.id
            })
          }
          this.payment_request_detail.push(param)
          // }
        }
        setTimeout(() => {
          document.getElementById('billingPayreqForm').click()
        }, 300)
      }
      if (val == 'close') {
        this.clearSelectedData()
      }
    },
    getDropdownUnit() {
      axios
        .get(`${this.proc}master/unit/drop_down?keyword=`)
        .then((res) => {
          this.dropdown.unit = res.data.data
        })
        .catch((err) => {
          console.log(err)
        })
    },
    getDropdownCurrency() {
      axios
        .get(`${this.proc}master/currency/drop_down?keyword=`)
        .then((res) => {
          // console.log('currency>>>', res.data)
          this.dropdown.currency = res.data.data
        })
        .catch((err) => {
          console.log(err)
        })
    },
    async getDataMenu() {
      this.isLoadingPage = true
      const split = this.$route.path.split('/')
      // const routeModule = '/' + split[1] + '/' + split[2]
      const routeModule = '/' + split[1] + '/' + 'payreq'
      console.log('Path>>>>>', routeModule)
      await this.getMenuId({
        keyword: this.paramAPI.keyword,
        path: routeModule
      })
        .then((result) => {
          if (result.data.status_code === '00') {
            const menuId = result.data.data[0].id
            this.userLevel = this.getUserProfile.level.find(
              ({ application }) =>
                application.id ===
                  this.config.application.ecatalogue.applicationId ||
                application.id === this.config.application.all.applicationId
            )
            console.log('userLevel>>>>>', this.userLevel)
            if (this.userLevel !== null) {
              if (
                this.getUserProfile.level.find(
                  ({ id }) => id == this.appLevel.administrator
                ) !== undefined
              ) {
                this.resetPermission({
                  data: {
                    read_perm: 1,
                    create_perm: 1,
                    update_perm: 1,
                    delete_perm: 1
                  }
                })
              } else {
                this.checkMenuAccess([menuId, this.userLevel.id])
              }
            } else {
              this.resetPermission(null)
            }
          } else {
            this.isLoadingPage = false
          }
        })
        .catch((err) => {
          console.log(err)
          this.isLoadingPage = false
        })
    },
    async checkMenuAccess(payload) {
      await this.menu_access(payload)
        .then((result) => {
          console.log('menuAccess>>>>', result)
          this.resetPermission(result)
        })
        .catch((err) => {
          console.log(err)
          this.resetPermission(null)
        })
    },
    resetPermission(val) {
      this.permission = null

      if (val !== null) {
        if (val.data !== null) {
          if (val.data.read_perm === 1) {
            this.permission = val.data
            this.initDataForLayout()
          }
        }
      }
      this.isLoadingPage = false
    },
    async initDataForLayout() {
      if (this.userLevel.is_support) {
        this.paramAPI.company_id = {
          id: 0,
          name: ''
        }
      } else {
        this.paramAPI.company_id = {
          id: Number(this.getUserProfile.employee.company.plant_id),
          name: this.getUserProfile.employee.company.name
        }
      }

      if (
        this.getUserProfile.level.find(
          ({ id }) => id == this.appLevel.adminMaster
        ) !== undefined
      ) {
        this.paramAPI.mode = ''
      }
      if (this.getInvoicePageQuery !== null) {
        this.paramAPI = this.getInvoicePageQuery
      }
      setTimeout(async () => {
        this.initDropdown()
        await this.getDataFromApi()
      }, 200)
    },
    showMsgDialog(pModalType, pStatusMsg, pBtnCancel) {
      return new Promise((resolve) => {
        this.$swal
          .fire({
            position: 'center',
            icon: pModalType,
            html: '<strong style="font-size:18px;">' + pStatusMsg + '</strong>',
            showConfirmButton: true,
            showCancelButton: pBtnCancel,
            cancelButtonText: 'No'
          })
          .then((r) => {
            resolve(r)
          })
      })
    },
    resetSomeParam() {
      // this.paramAPI.limit = this.paramAPI.itemsPerPage
      this.paramAPI.page = 1
      this.paramAPI.offset = 0
      this.paramAPI.limit = 10
      this.paramAPI.itemsPerPage = 10
    },
    searchEnter() {
      this.resetSomeParam()
      this.getDataFromApi()
    },
    async initDropdown() {
      this.getDropdownCompany()
      this.dropdownStatus()
    },
    companyWatcher(v) {
      this.resetSomeParam()
      this.getDataFromApi()

      if (v != null) {
        // this.dropdownDepartment()
      } else {
        // this.dropdown.department = []
      }
    },
    departmentWatcher() {
      this.resetSomeParam()
      this.getDataFromApi()
    },
    async statusWatcher(v) {
      this.paramAPI.state = v
      this.resetSomeParam()
      setTimeout(async () => {
        await this.getDataFromApi()
      }, 100)
    },
    async startDateWatcher(v) {
      this.resetSomeParam()
      setTimeout(async () => {
        await this.getDataFromApi()
      }, 100)
    },
    async endDateWatcher(v) {
      this.resetSomeParam()
      setTimeout(async () => {
        await this.getDataFromApi()
      }, 100)
    },
    async partnerWatcher(v) {
      this.resetSomeParam()
      setTimeout(async () => {
        await this.getDataFromApi()
        if (v == null) {
          this.dropdown.partner = []
        }
      }, 100)
    },
    dropdownStatus() {
      this.dropdown.status = [
        // {
        //   id: 'draft',
        //   name: 'Draft'
        // },
        {
          id: 'posted',
          name: 'Posted'
        }
        // {
        //   id: 'cancelled',
        //   name: 'Cancelled'
        // }
      ]
    },
    async getDropdownCompany() {
      if (this.userLevel !== null) {
        // if (this.userLevel.is_admin !== null) {
        if (this.userLevel.user_user_level !== null) {
          if (
            this.userLevel.user_user_level.allowed_company === null ||
            this.userLevel.user_user_level.allowed_company.length === 0
          ) {
            this.dropdownCompanyApi()
          } else {
            this.dropdown.company =
              this.userLevel.user_user_level.allowed_company
            this.isDisableCompanyDropdown = false
          }
        } else {
          this.dropdownCompanyApi()
        }
        // }
      }
      // else {
      //   this.dropdownCompanyApi()
      // }
    },
    async dropdownCompanyApi() {
      if (Number(this.getUserProfile.employee.company.plant_id) !== 6) {
        this.isDisableCompanyDropdown = this.userLevel.is_support
      } else {
        this.isDisableCompanyDropdown = false
      }
      axios
        .get(`${this.eSanqua}master/universal/plant/dropdown`)
        // .get(`${this.odooApi}master/universal/res_company/dropdown`)
        .then((res) => {
          this.dropdown.company = res.data.data
        })
        .catch((err) => {
          console.log(err)
        })
    },
    async dropdownPartner(v) {
      axios
        .get(
          `${this.odooApi}res_partner/customer/dropdown?keyword=${v}&offset=0&limit=100`
        )
        .then((res) => {
          if (res.data.status_code == '00') {
            this.dropdown.partner = res.data.data
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    async getDataFromApi() {
      this.loading = true

      await this.initDataTable()
        .then((data) => {
          if (data && data.status_code == '00') {
            this.totalData = Number(data.total_record)
            return (this.tabelData = data.data)
          } else {
            this.showMsgDialog(
              'warning',
              `${data.status_msg}: ${data.error_msg[0].msg} (${data.error_msg[0].param})`,
              false
            )
          }
          this.totalData = 0
          return (this.tabelData = [])
        })
        .catch((err) => {
          console.log(err)
          return (this.tabelData = [])
        })
      this.skeleton_loading = false
      this.loading = false
    },
    async initDataTable() {
      console.log(this.paramAPI.company_id)
      let url = `${this.odooApi}account_move/list?keyword=${this.paramAPI.keyword}`

      if (this.paramAPI.offset != null && this.paramAPI.limit != null) {
        url =
          url +
          `&offset=${this.paramAPI.offset * this.paramAPI.limit}&limit=${
            this.paramAPI.limit
          }`
      }
      if (this.paramAPI.sortBy != null && this.paramAPI.sortType != null) {
        url =
          url +
          `&order_by=${this.paramAPI.sortBy}&order_type=${this.paramAPI.sortType}`
      }
      if (this.paramAPI.state !== null) {
        url = url + `&state=${this.paramAPI.state}`
      }
      if (this.paramAPI.company_id !== null) {
        url = url + `&company_id=${this.paramAPI.company_id.id}`
      }
      if (this.paramAPI.start_date !== null) {
        url = url + `&start_date=${this.paramAPI.start_date}`
      }
      if (this.paramAPI.end_date !== null) {
        url = url + `&end_date=${this.paramAPI.end_date}`
      }
      if (this.paramAPI.partner_id) {
        url = url + `&partner_id=${this.paramAPI.partner_id}`
      }
      url = url + `&type=${'in_invoice'}`
      this.setInvoicePageQuery(this.paramAPI)
      return await new Promise((resolve) => {
        axios
          .get(url)
          .then((res) => {
            console.log('list invoice >>>>', res)
            resolve(res.data)
          })
          .catch((err) => {
            console.log(err)
          })
      })
    },
    // getDropdownVendor(val) {
    //   val && val != this.selectVendor && this.querySelections(val)
    // },
    // async querySelections(v) {
    //   await axios
    //     .get(
    //       `${this.proc}vendor/dropdown?keyword=${v}&offset=0&limit=100&order_by=name&order_type=asc`
    //     )
    //     .then((res) => {
    //       this.loading = false
    //       if (res.data.status_code === '00') {
    //         return (this.dropdown.vendor = res.data.data)
    //       }
    //       return (this.dropdown.vendor = [])
    //     })
    //     .catch((err) => {
    //       this.dropdown.vendor = []
    //       return console.log(err)
    //     })
    // },

    // vendorCustomFilter(item, queryText, itemText) {
    //   return (
    //     item.name.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) >
    //       -1 ||
    //     item.code.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) >
    //       -1
    //   )
    // },
    rowClick(pValue, pSlot) {
      // const arrItem = {
      //   list: this.result
      //   // index: pSlot.index
      // }
      // this.$store.commit('setPayreqQueue', arrItem)
      // setTimeout(() => {
      //   this.$router.push(
      //     `/e-catalogue/payreq/detail/${pValue.id}?idx=${pSlot.index}`
      //   )
      // }, 200)
    },
    async updatePage(p) {
      console.log('update page>>>', p)
      this.paramAPI.page = p
      this.paramAPI.offset = p - 1
      await this.getDataFromApi()
    },
    async updateItemPerPage(p) {
      console.log('update updateItemPerPage>>>', p)
      this.paramAPI.itemsPerPage = p
      this.paramAPI.limit = p
      this.paramAPI.offset = 0
      await this.getDataFromApi()
    },
    convertDate(raw) {
      if (raw !== null) {
        const date = new Date(raw)
        const local = date.toLocaleString('id')
        return local
      } else {
        return '-'
      }
    }
  }
}
</script>
<style lang="scss">
#invoiceList {
  position: relative;
  .invoice-list-dev {
    padding: 15px;
    min-height: 50vh;
    display: flex;
    justify-content: center;
    align-items: center;

    .invoice-list-toolbar-1 {
      .invoice-list-toolbar-1 {
        width: 60%;
        display: flex;
        flex-direction: row;
        margin-left: auto;
      }
    }
    .activity-list-toolbar-2 {
      display: none;
    }
  }
}

@media (max-width: 768px) {
  #invoiceList {
    .invoice-list-dev {
      .invoice-list-toolbar-1 {
        .invoice-list-toolbar-1 {
          display: none;
        }
      }
      .activity-list-toolbar-2 {
        display: block;
      }
    }
  }
}
</style>
